import React from 'react'
import {ReadCommitResult} from 'isomorphic-git'
import {faCodeBranch} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import styles from "./index.module.scss"

interface CommitDetailsRowProps {
  commit: ReadCommitResult
  commitNumber: number
  seeDiff?: boolean
}

export const CommitDetailsRow = (props: CommitDetailsRowProps) => {
  const {commit: {commit}, seeDiff, commitNumber} = props

  const onClick = () => {}

  return (
    <div className={styles.Container}>
      <div className={styles.Content}>
        <div>
          <FontAwesomeIcon icon={faCodeBranch} />
          <p className={styles.Title}>{commit.message}</p>
        </div>
        <div>
          <p className={styles.Message}>
            {`#${commitNumber} commited by `}
          </p>
          <u className={styles.Message}>{commit.committer.name}</u>
        </div>
      </div>
      {seeDiff === true && <button 
        className={styles.Button}
        onClick={onClick}
      >SEE DIFF</button>}
    </div>
  )
}